export function LoadingSpinner() {
  return (
    <div className="loading-container" aria-live="polite" aria-busy="true">
      <div className="loading-spinner" aria-hidden="true" />
      <span>Loading…</span>
    </div>
  );
}
